import { useAppSelector } from '@shared/store';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyVideoDemoPeriod = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyVideoDemoPeriod);
};
